// import config from './config'
import { http, helper } from '@ymt/gfw-axios'
import config from '@/config'
// const gfwInitVersion = parseInt(localStorage.getItem('gfw_init_version')) // 客户端最后一次更新版本
// const lastChangeVersion = 3 // 代码最后一次更新时间
// let cleanInitStatus = true
// if (gfwInitVersion === lastChangeVersion) {
//   cleanInitStatus = false
// }
// if (cleanInitStatus) {
//   localStorage.setItem('gfw_init_version', lastChangeVersion)
//   helper.clearSid()
//   helper.clearUUID()
// }
http.setEnv({
  appKey: '4001', //
  extra: `&fCode=${config.fcode}`, // url里追加的额外参数
  baseUrl: config.baseUrl
}) // (必选) 设置网关的baseUrl

// header组件
export class header {
  // 取得用户信息
  static getUserinfo() {
    return http.post(`/uc/ucenter/userinfo/appget_uinfos.json`, {})
  }
  static logout() {
    return http.get(`/uc/auth/logout/applogout.json`, {})
  }
}
// 菜单
export class menu {
  // 取得菜单
  static getMenu() {
    return http.get('/crm-authorization/api/mobileCrm/menu', {})
  }
  phome
}
// 菜单&&首页
export class home {
  // 取得用户信息
  static getUserinfo() {
    return http.post(`/uc/ucenter/userinfo/appget_uinfos.json`, {})
  }
  static logout() {
    return http.post(`/uc/auth/logout/applogout.json`, {})
  }
  // 营收分析
  static incomestats(param) {
    return http.post(`/ymtpay_bill/analysis/income/stats`, param)
  }
  static orderstats(param) {
    return http.post(`/ymtpay_bill/analysis/order/stats`, param)
  }
  static sellerData(param) {
    return http.post(`/seller-home/v1/seller-main-page`, param)
  }
}
// 登录
export class login {
  // 发送
  static sendsms({
    mobile,
    code_str,
    captcha
  }) {
    return http.post(`/uc/login/phoneverify/websendsms.json`, {
      mobile,
      code_str,
      captcha
    })
  }
  // 取验证码
  static getCaptcha() {
    // return http.get('http://uc-captcha.uc-test.ymt360.com/captcha/api/getcodestr.json')
    return http.get('/captcha/api/getcodestr.json')
  }

  // 校验验证码
  static verifysms({
    mobile,
    vcode
  }) {
    return http.post(`/uc/login/phoneverify/webverifysms.json`, {
      mobile,
      vcode
    })
  }
}
// 供应管理
export class supply {
  // 取得供应列表
  static getList({
    onSale,
    pageStart,
    pageSize
  }) {
    return http.post('/supply_mgr/v15/list_supply', {
      on_sale: onSale, // 1上架 0下架 2 拒审
      start: pageStart, // 偏移位置 从0开始 下一页 + page_size
      page_size: pageSize, // 翻页长度
      is_show_popup: 0 // 1展示弹窗
    })
  }
  // 刷新价格
  static editPrice({
    supplyId,
    priceLarge,
    priceLargeAmount,
    priceUnit
  }) {
    return http.post('/supply_mgr/v12/supply/edit_price', {
      supply_id: supplyId, // int
      supply_price: {
        price_large: priceLarge, // string
        price_large_amount: priceLargeAmount || '', // string
        price_unit: priceUnit // int
      }
    })
  }
  static refreshAll() {
    return http.post('/supply_mgr/v14/refresh_all_supply', {})
  }
  // 刷新
  static refresh({
    supplyId
  }) {
    return http.post('/supply_mgr/v11/supply/refresh_supply', {
      supply_id: supplyId
    })
  }
  //  上架
  static open(param) {
    return http.post('/supply_mgr/v11/supply/open_supply', param)
  }
  // 下架
  static close(param) {
    return http.post('/supply_mgr/v11/supply/close_supply', param)
  }
  // 删除
  static toDel(param) {
    return http.post('/supply_mgr/v11/supply/delete_supply', param)
  }
}
// 发布供应
export class publish {
  // 切词
  static guessWord(param) {
    return http.post('/supply_wordseg/app/query_parser', param)
  }
  // 搜索列表
  static guessSuggests(param) {
    return http.get(`/cp/v1/product/suggest?term=${param}`)
  }
  // 获取产品规格
  static getUnits(productId) {
    return http.post('/cp/v1/product/get-spec', productId)
  }
  // 获取发货地地址
  static getLocation(id) {
    return http.post(`/jy/location/v2/sublist?locid=${id}`)
  }
  static publishSupply(param) {
    return http.post('/supply_mgr/v13/publish_supply', param)
  }
  static publishSupplyDouniu(param) {
    return http.post('/optimall/service/publish_supply.json', param)
  }
  // 获取运费模板
  static getExpress(param) {
    return http.post('/cp/v1/sell_attribute/schema', param)
  }
  // 获取运费模板下拉列表
  static getExpressList(param) {
    return http.post('/supply_mgr/v1/list_logistic_tpl', param)
  }
  // 供应详情
  static getSupplyDetail(param) {
    return http.post('/supply_mgr/v13/edit_info', param)
  }
  // 编辑供应
  static editSupply(param) {
    return http.post('/supply_mgr/v13/edit_supply', param)
  }
  // 编辑供应
  static editSupplyDouniu(param) {
    return http.post('/optimall/service/edit_supply.json', param)
  }
  // 供应商列表
  static getVendorList(param) {
    return http.post('/optimall/service/vendor_list.json', param)
  }
  // 校验权限
  static checkPrevillige({resId}) {
    return http.get(`/crm-authorization/api/mobileCrm/auth/checkPrevillige/?resId=${resId}`)
  }
  // 关联供应供应商
  static relateVendorSupply(param) {
    return http.post(`/optimall/service/related_vendor_supply.json`, param)
  }
  // 编辑找到对应供应商
  static getVendor(param) {
    return http.post(`/optimall/service/get_vendor.json`, param)
  }
}
// 订单管理
export class orderList {
  static marketList() {
    return http.post('/commission/market/market_list_rpc.json')
  }
  static getAccountList(param) {
    return http.post('/commission/merchandiser/merchandiser_list_rpc.json', param)
  }
  // 取得物流费用结算账户
  static merchandiserList(param) {
    return http.post('/commission/merchandiser/merchandiser_list.json', param)
  }
  static getList(param = {}) {
    return http.post('/orderv3_read/seller_order_list', param)
    // return http.post('order/order_list', param)
  }
  // 供货订单列表
  static getSupplyList(param = {}) {
    return http.post('/orderv3_read/seller_enterprise_purchase_order_list', param)
  }
  // 卖有确认订单
  static checkOrder(param) {
    return http.post('/orderv3_core/check_order', param)
  }
  // 卖家拒绝订单
  static sellerReject(param) {
    return http.post('/orderv3_core/seller_reject?lat=0&lng=0', param)
  }
  // 提交发货凭证
  static sellerSendGoods(param) {
    return http.post('/orderv3_core/seller_send_goods?lat=0&lng=0', param)
  }
  // 物流列表
  static delivery(param) {
    return http.post('/orderv3_read/delivery?lat=0&lng=0', param)
  }
  // 同意退款
  static agreeRefund(param) {
    return http.post('/orderv3_core/seller_agree_refund?lat=0&lng=0', param)
  }
  // 拒绝退款
  static rejectRefund(param) {
    return http.post('/orderv3_core/seller_reject_refund?lat=0&lng=0', param)
  }
  // 退款详情
  static refundDetail(param) {
    return http.post('/orderv3_read/refund_detail?lat=0&lng=0', param)
  }
  // 导出订单列表
  static exportOrderList(param) {
    return http.post('/orderv3_read/export/excel', param, {
      responseType: 'blob'
    })
  }
  // 导出供应订单列表
  static exportSupplyOrderList(param) {
    return http.post('/orderv3_read/purchase_order_export/excel', param, {
      responseType: 'blob'
    })
  }
}
// 批量导出
export class batchSendGoods {
  static uploadFile(parms, config) {
    return http.post('/orderv3_core/batch_send_goods', parms, config)
  }
  // PC获取批量发货结果
  static getList(parms) {
    return http.post('/orderv3_read/batch_result', {
      access_token: 'access_token',
      data: {
        index: parms.index,
        page: parms.page
      }
    })
  }
  static getDownloadUrl(parms) {
    return http.post('/orderv3_read/batch_download', {
      access_token: 'access_token',
      data: {
        batch_no: parms.batch_no
      }
    })
  }
}
// 聊天
export class chat {
  // websocket注册接口
  static websocketReg(param) {
    return http.post(`/pub/v10/appim/default/websocket_reg.json`, param)
  }
  // 好友列表
  static chatList(param) {
    return http.post(`/pub/v10/appim/init_dialog/dialog_list.json`, param)
  }
  // 当前历史消息
  static historyMsg(param) {
    return http.post(`/pub/v10/appim/init_msg`, param)
  }
  // 新消息
  static newMsg(param) {
    return http.post(`/pub/v10/appim/new_msg_all`, param)
  }
  // 发送消息
  static send(param) {
    return http.post(`/pub/v10/appim/send_message`, param)
  }
  // 修改消息状态
  static ackById(param) {
    return http.post(`/pub/v10/appim/msg_ack/AckById.json`, param)
  }
  // 订单列表
  static orderList(param) {
    return http.post(`/orderv3_read/chat_order_list`, param)
  }
  // 我的供应
  static supplyList(param) {
    return http.post(`/supply_mgr/v15/list_supply`, param)
  }
  // 订单创建
  static createOrder(param) {
    return http.post(`/orderv3_core/create_order?lat=0&lng=0`, param)
  }
  // 通话记录
  static callRecord(param) {
    return http.post(`/uc/call/record/relationdetail.json`, param)
  }
}
// 物流模板
export class delivery {
  // 模版列表
  static listLogisticTpl(param) {
    return http.post(`/supply_mgr/v1/list_logistic_tpl`, param)
  }
  // 发布物流模版
  static publishLogisticTpl(param) {
    return http.post(`/supply_mgr/v1/publish_logistic_tpl`, param)
  }
  // d单位列表
  static getunitsList() {
    return http.post(`/cp/v1/units`)
  }
  // 地区列表
  static getSublist() {
    return http.post(`/jy/location/v2/sublist?logid=0&locid=0`)
  }
}
// 商家管理
export class merchant {
  // 微信小程序商家查询
  static getMerchantList(param) {
    return http.post(`/hangqing_ditu/api/weixin_page_list`, param)
  }
  // 微信小程序商家添加
  static addMerchantList(param) {
    return http.post(`/hangqing_ditu/api/weixin_page_add`, param)
  }
  // 微信小程序商家更新
  static updateMerchantList(param) {
    return http.post(`/hangqing_ditu/api/weixin_page_update`, param)
  }
  // 微信小程序商家更新
  static deleteMerchantList(param) {
    return http.post(`/hangqing_ditu/api/weixin_page_del`, param)
  }
  static getGoodList(param) {
    return http.post(`/supply_mgr/v14/list_supply`, param)
  }
  static getUserId(param) {
    return http.post(`/hangqing_ditu/api/get_user_cid`, param)
  }
}
// 视频管理
export class videoManagement {
  // 获取子账号列表
  static getChildrenList(page= 1,perPage = 200 ) {
    return http.get(`/ai-media/ai/media/acct/auth/accounts?page=${page}&per_page=${perPage}`)
  }
  // 设置子账号
  static setChildrenAccount(proxyCid) {
    return http.post(`/ai-media/ai/media/acct/auth/account`, {
      proxyCid
    })
  }
  // 获取当前授权账号信息
  static getCurrentAccount() {
    return http.get(`/ai-media/ai/media/acct/auth/account`)
  }
  // 获取主题列表接口
  static getTemplateList(cid,page= 1,perPage = 999 ) {
    if (cid) {
      return http.get(`/ai-media/ai-media/script/template?page=${page}&per_page=${perPage}&cidList=${cid}`)
    } else {
      return http.get(`/ai-media/ai-media/script/template?page=${page}&per_page=${perPage}`)
    }
  }
  // 开始创造接口（素材召回\创建剧本）
  static createAigc(templateId, userDesc, productId, docIds) {
    return http.post(`/ai-media/ai-media/script/instance/create`, {
      templateId,
      userDesc,
      productId,
      docIds
    })
  }
  // 获取生成历史
  static getCreateHistory(paramStrings) {
    return http.get(`/ai-media/ai-media/script/instance/list?${paramStrings}`)
  }
  // 剧本详情查询
  static getScriptDetail(scriptId) {
    return http.get(`/ai-media/ai-media/script/instance/detail/${scriptId}`)
  }
  // 更新剧本实例
  static updateScript({id,storyBoard, styleDetail}) {
    return http.post(`/ai-media/ai-media/script/instance/update`, {
      id,
      storyBoard,
      styleDetail
    })
  }
  /**
   * 生成视频样品接口、生成视频成品接口、复制接口
   * 参数说明{
   "type": "final", //example:样片, final:成片, finalMediaJobId:成片根据任务表id生成
   "count": 1, //成品数 只有type为final时需要该参数
   "scriptId": 38, //剧本id 必传
   "videoId": 1, //根据样片id生成视频 只有type为finalMediaJobId时需要该参数
   "videoName": "视频名称" //只有type为example时需要该参数
   }
  */
  static generateVideo(param) {
    return http.post(`/ai-media/ai-media/script/instance/generateVideo`, {
      ...param
    })
  }
  // 样片/成片手动置停止
  static cancelGenerateVideo(mediaJobId) {
    return http.post(`/ai-media/media/job/${mediaJobId}/stop`)
  }
  // 成片手动删除
  static deleteVideo(mediaJobId) {
    return http.delete(`/ai-media/media/job/${mediaJobId}`)
  }
  // 获取成片列表
  static getBusDataList(scriptId) {
    return http.get(`/ai-media/media/job?per_page=50&scriptId=${scriptId}`)
  }
  // 字典的缓存
  static dictCache = {}
  // 获取字典
  static getDictList(dictCode) {
    if (this.dictCache[dictCode]) {
      return this.dictCache[dictCode]
    }
    this.dictCache[dictCode] = http.get(`/crm-dict/dict/dictType/${dictCode}/list`)
    return this.dictCache[dictCode]
  }
  // 根据相似乎度获取分镜素材
  static getMaterialMeida(mediaDesc, includePublic, fileType) {
    return http.post('/scrm-dcc/scrm/dcc/ai/media/match', {
      busType: 110001,
      size: 300,
      fileType,
      includePublic,
      mediaDesc: mediaDesc
    })
  }
  // 获取分镜素材列表
  static getMaterialList(params) {
    return http.get('/scrm-dcc/scrm/dcc/ai/media/list', {
      params: {
        order: 'id',
        direction: 'desc',
        busType: 110001,
        ...params
      }
    })
  }
  static getMaterialDetail(id) {
    return http.get('/scrm-dcc/scrm/dcc/ai/media/detail', {
      params: {
        id
      }
    })
  }
  static getMaterialUpdate(data) {
    return http.post('/scrm-dcc/scrm/dcc/ai/media/update', data)
  }
  static getHtmlPreview(data) {
    return http.post('/html2img/aigc_img', data)
  }
  static getMaterialRebuild(id) {
    return http.post('/scrm-dcc/scrm/dcc/ai/media/rebuild', {
      id
    })
  }
  static getMaterialAdd(data) {
    return http.post('/scrm-dcc/scrm/dcc/ai/media/batch/add', data)
  }
  static getAccountList(vendorType, customerId) {
    return http.get('/ai-media/ai-media/aigc/vendor/acct', {
      params: {
        page: 1,
        per_page: 1000,
        vendorType,
        customerId
      }
    })
  }
  static getMediaList(params) {
    return http.get('/ai-media/media/job', {
      params
    })
  }
  static publishCreate(data) {
    return http.post('/ai-media/publish/create', data)
  }
  static getPublishTaskList(params) {
    return http.get('/ai-media/workflow/query', {
      params: {
        type: 'ai_publish_job',
        order: 'expectedTime',
        direction: 'desc',
        ...params
      },
      headers: {
        "crm-login": "E:4073"
      }
    })
  }
  static getPublishTaskStatus(params) {
    return http.get('/ai-media/workflow/query/progress', {
      params: {
        type: 'ai_publish_job',
      },
      headers: {
        "crm-login": "E:4073"
      }
    })
  }
  static postTaskItem(data) {
    return http.post('/ai-media/workflow/push', {
      processName: 'ai_publish_job',
      ...data
    }, {
      params: {
        type: 'ai_publish_job',
      },
      headers: {
        "crm-login": "E:4073"
      }
    })
  }
  static voiceCloneList(params = {}) {
    return http.get('/ai-media/ai/voice/clone', {
      params: {
        ...params
      }
    })
  }
  static voiceCloneUpdate(data = {}) {
    return http.post('/ai-media/ai/voice/clone/modify', data)
  }
  static voiceCloneAdd(data) {
    return http.post('/ai-media/ai/voice/clone', data)
  }
  static voiceCloneGen(data) {
    return http.post(location.origin + '/api/ai/voice/clone/gen', data)
  }
}

// 知识库
export class KnowledgeLibrary {
  // 文档素材列表
  static getList() {
    return http.get('/scrm-dcc/ai/document/mgmt/list')
  }
  // oss文本解析文本素材
  static uploadFile(list) {
    return http.post('/scrm-dcc/ai/document/mgmt/saveAndParse', list)
  }
  // 发起文档解析请求
  static fileParse(list) {
    return http.post('/scrm-dcc/ai/document/mgmt/parse', list)
  }
  // 删除指定文档
  static delFile(id) {
    return http.get(`/scrm-dcc/ai/document/mgmt/del/${id}`)
  }
  // 重新解析
  static reParse(id) {
    return http.get(`/scrm-dcc/ai/document/mgmt/reParse/${id}`)
  }
  static listAvailableDocuments() {
    return http.get('/scrm-dcc/ai/document/mgmt/listAvailableDocuments')
  }
}
